import { render, staticRenderFns } from "./Fenlei_Mayiba.vue?vue&type=template&id=7380acb0&"
import script from "./Fenlei_Mayiba.vue?vue&type=script&lang=js&"
export * from "./Fenlei_Mayiba.vue?vue&type=script&lang=js&"
import style0 from "./Fenlei_Mayiba.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports